export interface Bonus {
  id: string
  title: string
  desc: string
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'La Grammaire Espagnole Sans Stress',
    desc: "Un guide de référence grammaticale complet couvrant toutes les structures de Spanish 1 et Spanish 2 — écrit en français clair avec des tableaux, des exemples, une analyse des erreurs fréquentes, des exercices guidés, des exercices autonomes et des mini-quiz avec corrigés.",
    benefit: 'Pas de préparation nécessaire. Ouvre, consulte et enseigne.',
  },
  {
    id: '02',
    title: '150 Activités de Conversation',
    desc: "Une bibliothèque complète de 150 activités d'expression orale entièrement structurées — conversations en binômes, sondages en classe, jeux de rôle, descriptions d'images, mini-présentations, débats et situations de communication réelle. Tous les niveaux et tous les thèmes couverts.",
    benefit: 'Tes élèves parlent davantage. Tes cours prennent vie.',
  },
  {
    id: '03',
    title: 'Pack Complet d’Évaluations & Corrigés',
    desc: "Un pack complet d'évaluations pour Spanish 1 et Spanish 2 : évaluations de vocabulaire, examens de grammaire, tâches de lecture, activités de compréhension orale, sujets d'écriture, rubriques d'expression orale, révisions d'unités et évaluations de compétences mixtes. Versions élève, corrigés, versions adaptées et options de reprise tous inclus.",
    benefit: 'Avoir la bonne évaluation prête avant que la semaine commence.',
  },
  {
    id: '04',
    title: '40 Leçons de Culture Hispanophone',
    desc: "Une collection de 40 leçons culturelles complètes couvrant le monde hispanophone — Espagne, Mexique, Colombie, Argentine, Pérou, Chili, Amérique centrale et Caraïbes. Traditions, musique, danse, art, littérature, festivals et identité culturelle. Chaque leçon comprend lecture, vocabulaire, discussion et écriture.",
    benefit: 'Tes leçons culturelles se sentent authentiques, pas génériques.',
  },
  {
    id: '05',
    title: '50 Cours d’Urgence Prêts à l’Emploi',
    desc: "Une collection de 50 cours complets de secours pour les journées où tu n'as pas le temps de planifier. Chaque cours comprend : objectif, niveau, matériel, mise en place, point linguistique, activité guidée, pratique orale, travail écrit, vérification, correction, clôture et variantes. Tous avec corrigés.",
    benefit: "Tu n'entreras plus jamais en cours d'espagnol sans être prêt. Ouvre, choisis, enseigne.",
  },
]
